import TypographyParagraph from '../typography/TypographyParagraph'
import TypographyLabel from '../typography/TypographyLabel'
import PendingIndicator from './pendingIndicator'

const ProofOfExhibition = ({
	metadata,
	asCountersign = false,
}: {
	metadata: any
	asCountersign?: boolean
}) => {
	const mapStatus = (metadataEntry: any) => {
		//TODO string comparison can be removed when the BE returns a boolean instead of a string for isReattested
		if (
			(metadataEntry.isReattested === true ||
				metadataEntry.isReattested === 'true') &&
			metadataEntry.properties.countersignRequired === true
		)
			return 'Completed'
		if (
			(metadataEntry.isReattested === true ||
				metadataEntry.isReattested === 'true') &&
			metadataEntry.properties.countersignRequired === false
		)
			return 'Accepted'
		if (
			metadataEntry.isReattested !== true &&
			metadataEntry.properties.countersignRequired === false
		)
			return 'Completed'
		if (
			metadataEntry.isReattested !== true &&
			metadataEntry.properties.countersignRequired === true
		)
			return 'Pending'
		return ''
	}

	const truncateStringInMiddle = (str: string) => {
		if (!str) return ''
		if (!isValidEthereumAddress(str) && !isValidSolanaAddress(str)) return str
		if (str.length > 8) {
			return (
				str.substring(0, 4) + '...' + str.substring(str.length - 4, str.length)
			)
		} else {
			return str
		}
	}

	const isValidEthereumAddress = (address: string) => {
		const regex = /^(0x)?[0-9a-fA-F]{40}$/
		return regex.test(address)
	}

	const isValidSolanaAddress = (address: string) => {
		const regex = /^[1-9A-HJ-NP-Za-km-z]{44}$/
		return regex.test(address)
	}

	return (
		<div className="flex flex-col">
			{metadata.properties.description && (
				<div
					className={`${asCountersign ? 'flex-row items-center border-b border-textInactiveLight px-4 py-2 dark:border-textInactiveDark' : 'mb-4'}`}
				>
					<TypographyParagraph
						size="medium"
						additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark"
					>
						{metadata.properties.description}
					</TypographyParagraph>
				</div>
			)}
			<div
				className={`flex h-full w-full flex-col rounded bg-uiTertiaryLight dark:bg-uiTertiaryDark ${asCountersign ? '' : 'border border-textInactiveLight dark:border-textInactiveDark'}`}
			>
				<div
					id="exhibitionName"
					className="flex flex-row justify-between border-b border-textInactiveLight px-4 py-2 hover:bg-uiSecondaryLight dark:border-textInactiveDark dark:hover:bg-uiSecondaryDark"
				>
					<TypographyLabel
						size="medium"
						isBold={true}
						additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark break-words ml-1"
					>
						{metadata.properties.name}
					</TypographyLabel>
				</div>
				<div className="flex flex-col sm:flex-row">
					<div
						id="startDate"
						className="flex flex-col justify-between border-b border-textInactiveLight px-4 py-2 hover:bg-uiSecondaryLight dark:border-textInactiveDark dark:hover:bg-uiSecondaryDark sm:w-1/2 sm:border-r md:flex-row"
					>
						<TypographyParagraph
							size="medium"
							additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
						>
							Start date:
						</TypographyParagraph>
						<TypographyParagraph
							size="medium"
							additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark ml-1"
						>
							{metadata.properties.startDate}
						</TypographyParagraph>
					</div>
					<div
						id="endDate"
						className="flex flex-col justify-between border-b border-textInactiveLight px-4 py-2 hover:bg-uiSecondaryLight dark:border-textInactiveDark dark:hover:bg-uiSecondaryDark sm:w-1/2 md:flex-row"
					>
						<TypographyParagraph
							size="medium"
							additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
						>
							End date:
						</TypographyParagraph>
						<TypographyParagraph
							size="medium"
							additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark ml-1"
						>
							{metadata.properties.endDate}
						</TypographyParagraph>
					</div>
				</div>
				<div className="flex flex-col sm:flex-row">
					<div
						id="ownerWallet"
						className="flex flex-col justify-between border-b border-textInactiveLight px-4 py-2 hover:bg-uiSecondaryLight dark:border-textInactiveDark dark:hover:bg-uiSecondaryDark sm:w-1/2 sm:border-r md:flex-row"
					>
						<TypographyParagraph
							size="medium"
							additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
						>
							Owner:
						</TypographyParagraph>
						<TypographyParagraph
							size="medium"
							additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark break-all ml-1"
						>
							{truncateStringInMiddle(metadata.properties.ownerAddress)}
						</TypographyParagraph>
					</div>
					<div
						id="exhibitionWallet"
						className="flex flex-col justify-between border-b border-textInactiveLight px-4 py-2 hover:bg-uiSecondaryLight dark:border-textInactiveDark dark:hover:bg-uiSecondaryDark sm:w-1/2 md:flex-row"
					>
						<TypographyParagraph
							size="medium"
							additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
						>
							Exhibitor:
						</TypographyParagraph>
						<div className="ml-1 flex flex-row">
							<TypographyParagraph
								size="medium"
								additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark break-all flex"
							>
								{truncateStringInMiddle(metadata.properties.receiverAddress)}{' '}
							</TypographyParagraph>
							{mapStatus(metadata) == 'Pending' ? <PendingIndicator /> : ''}
						</div>
					</div>
				</div>
				<div className="flex flex-col sm:flex-row">
					{metadata.properties.location && (
						<div
							id="exhibitionLocation"
							className="flex flex-col justify-between border-b border-textInactiveLight px-4 py-2 hover:bg-uiSecondaryLight dark:border-textInactiveDark dark:hover:bg-uiSecondaryDark sm:w-1/2 sm:border-b-0 sm:border-r md:flex-row"
						>
							<TypographyParagraph
								size="medium"
								additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
							>
								Location:
							</TypographyParagraph>
							<TypographyParagraph
								size="medium"
								additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark truncate ml-1"
							>
								{metadata.properties.location}
							</TypographyParagraph>
						</div>
					)}
					{metadata.properties.url && (
						<div
							id="externalLink"
							className="flex flex-col justify-between border-textInactiveLight px-4 py-2 hover:bg-uiSecondaryLight dark:border-textInactiveDark dark:hover:bg-uiSecondaryDark sm:w-1/2 md:flex-row"
						>
							<TypographyParagraph
								size="medium"
								additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
							>
								Link:
							</TypographyParagraph>
							<TypographyParagraph
								size="medium"
								additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark truncate ml-1"
							>
								{metadata.properties.url}
							</TypographyParagraph>
						</div>
					)}
				</div>
			</div>
		</div>
	)
}

export default ProofOfExhibition
